import { ref } from 'vue'
import { defineStore } from 'pinia'
import {
  getEmployments,
  getEmployment,
  postEmployment,
  editEmployment,
  getUsers,
  getUsersFired,
  getUser,
  createUser,
  editUser
} from '../api/users'
import { getAvailableEmployees } from '@/api/exchange'
import { Employment } from '@/types'
import { useToast } from 'vue-toast-notification'

const toast = useToast({ position: 'bottom-right' })

export const useEmploymentStore = defineStore('employment', () => {
  // Состояния
  const employments = ref<Employment[]>([])
  const employees = ref<any[]>([])
  const users = ref<any[]>([])
  const user = ref<any>(null)
  const usersCount = ref<number>(0)
  const loading = ref<boolean>(false)
  const selectedEmployment = ref<any>(null)
  const selectedEmploymentSchedule = ref<any>(null)

  async function fetchEmployments() {
    try {
      const res = await getEmployments()
      employments.value = res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function fetchAvailableEmployees(data: any) {
    try {
      const res = await getAvailableEmployees(data)
      employees.value = res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function addUser(data: any) {
    try {
      const res = await createUser(data)
      console.log(res.data.body)
      return res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function fetchUsers(params: any) {
    users.value = []
    try {
      const res = await getUsers(params)
      users.value = res.data.body.results
      usersCount.value = res.data.body.count
    } catch (err: any) {
      return err
    }
  }

  async function fetchUser(id: string) {
    try {
      const res = await getUser(id)
      user.value = res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function fetchUsersFired(params: any) {
    users.value = []
    try {
      const res = await getUsersFired(params)
      users.value = res.data.body.results
      usersCount.value = res.data.body.count
    } catch (err: any) {
      return err
    }
  }

  async function userEdit(id: string, data: any) {
    try {
      await editUser(data, id)
      if (user.value?.id === id) {
        user.value = { ...user.value, ...data }
      }
      toast.success('Сохранено успешно')
    } catch (err: any) {
      toast.error(err.response.body)
      return err
    }
  }

  async function fetchEmployment(id: string) {
    try {
      selectedEmployment.value = null
      const res = await getEmployment(id)
      selectedEmployment.value = res.data.body
      return res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function createEmployment(data: any) {
    try {
      const res = await postEmployment(data)
      toast.success('Трудоустройство добавлено успешно')
      return res.data.body
    } catch (err: any) {
      return err
    }
  }

  async function changeEmployment(id: string, data: any) {
    try {
      await editEmployment(id, data)
      toast.success('Сохранено успешно')
    } catch (err: any) {
      toast.error(err.response.body)
      return err
    }
  }

  return {
    // Состояния
    employments,
    employees,
    users,
    user,
    usersCount,
    loading,
    selectedEmployment,
    selectedEmploymentSchedule,

    // Функции
    fetchEmployments,
    fetchEmployment,
    createEmployment,
    changeEmployment,
    fetchUsers,
    fetchUsersFired,
    fetchUser,
    addUser,
    userEdit,
    fetchAvailableEmployees
  }
})
